import React from 'react'

import { tenants } from '../../core/controllers/tenants'
import { modal } from '../../core/utilities/modal'

export default class TenantsAlert extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            subject: '',
            message: ''
        }
    }

    handleMessageChange(e) {
        this.setState({
            message: e.target.value
        });
    }

    handleSubjectChange(e) {
        this.setState({
            subject: e.target.value
        });
    }

    validate() {
        if(this.state.subject === '') {
            modal.showInfo("Enter a subject.", "warning", "top", "center");
            return false;
        }

        if(this.state.message === '') {
            modal.showInfo("Enter a message.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    sendAlert() {
        var self = this;
        if(!this.validate()) {
            return;
        }

        tenants.sendAlerts(this.state, function() {
            self.setState({
                subject: '',
                message: ''
            });
        });
    }

    render(){
        const subject = this.state.subject;
        const message = this.state.message;

        return (
            <div class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="email">Subject</label>
                            <input type="text" value={subject} onChange={this.handleSubjectChange.bind(this)} class="form-control tenant-info" name="subject" placeholder="Subject" id="subject"/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="email">Message</label>
                            <textarea rows="4" cols="80" class="form-control" placeholder="Let your tenants know what is going on." value={message} onChange={this.handleMessageChange.bind(this)}/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button type="button" id="save-message" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.sendAlert.bind(this)}>
                        Send Alert
                        </button>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Tenants/TenantsAlert.jsx